import React, { useState } from 'react';
import { Button, Checkbox, PopUp } from 'geniebook-ui/dist';

export interface UnsubscribeReasonPopUpProps {
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

const UnsubscribeReasonPopUp = (props: UnsubscribeReasonPopUpProps) => {
  const [selectedReasons, setSelectedReasons] = useState<number[]>([]);
  const [additionalReason, setAdditionalReason] = useState('');

  const reasons: IReason[] = [
    {
      id: 1,
      reason: "My child isn't interested in Geniebook",
    },
    {
      id: 2,
      reason: "My child doesn't have time",
    },
    {
      id: 3,
      reason: 'Prefer 1-1 physical tuition',
    },
    {
      id: 4,
      reason: 'Subscription is too expensive',
    },
    {
      id: 5,
      reason: "Didn't see academic improvement",
    },
    {
      id: 6,
      reason: 'Other',
    },
  ];

  function canSubmit() {
    return (
      selectedReasons.length > 0 &&
      !(selectedReasons.includes(6) && !additionalReason)
    );
  }

  function handleSubmit() {
    if (!canSubmit()) {
      return;
    }

    let reasonToSend: string = selectedReasons
      .map(id => reasons.find(item => item.id === id)?.reason)
      .join(', ');
    if (additionalReason) {
      reasonToSend += ', ' + additionalReason;
    }

    props.onSubmit(reasonToSend);
  }

  function handleClose() {
    props.onClose();
  }

  function handleSelectCheckbox(id: number) {
    const selection: number[] = JSON.parse(JSON.stringify(selectedReasons));

    if (selection.includes(id)) {
      selection.splice(selection.indexOf(id), 1);
    } else {
      selection.push(id);
    }

    setSelectedReasons(selection);
  }

  interface IReason {
    id: number;
    reason: string;
  }

  return (
    <PopUp
      onClose={() => {}}
      className={'px-8 py-6 max-w-[400px]'}
      buttonGroup={
        <div>
          <Button
            className={
              '!max-w-[calc(100%-2px)] !h-[56px] !font-extrabold hover:transform hover:!scale-[1.01]'
            }
            onClick={handleSubmit}
            disabled={!canSubmit()}
          >
            Submit
          </Button>
          <Button
            className={'!max-w-[calc(100%-2px)] !h-[56px] !font-extrabold'}
            variant={'secondary'}
            onClick={handleClose}
          >
            Dismiss
          </Button>
        </div>
      }
      description={
        <div>
          {reasons.map(reason => {
            return (
              <div
                key={reason.id}
                className={'mb-4 text-left [&_svg]:w-[21px] [&_svg]:h-[24px]'}
                onClick={event => {
                  event.preventDefault();
                  handleSelectCheckbox(reason.id);
                }}
                data-testid={'option-' + reason.id}
              >
                <Checkbox
                  id={reason.id.toString()}
                  label={reason.reason}
                  isChecked={selectedReasons.includes(reason.id)}
                  isValidation={false}
                />
              </div>
            );
          })}
          <div>
            <p className={'text-left font-semibold text-primary-navyblue mb-2'}>
              Please elaborate:
            </p>
            <textarea
              className={
                'w-full h-[90px] rounded-xl px-4 py-3 border focus-visible:outline-primary-apricot'
              }
              placeholder={'Any additional feedback'}
              onChange={event => setAdditionalReason(event.target.value)}
              value={additionalReason}
            />
          </div>
        </div>
      }
      title={
        <div className={'font-extrabold text-xl leading-[1.5]'}>
          Before you go, why are you cancelling?
        </div>
      }
    />
  );
};

export default UnsubscribeReasonPopUp;
